import { nullCheck } from "../utils/dataHelpers";

export default class ContactSerializer {
  static serialize(data) {
    const payload = {
      __type: data.contactType,
      ...data,
      id: data.id,
      name: data.name,
      phone: data.phone,
      mobile_phone: data.mobile,
      fax: data.fax,
      email: data.email,
      parent_row_id: data.carrierId,
      parent_row_type: data.contactAssociation,
      is_active: data.isActive,
      dispatch: data.isDispatch,
      billing: data.isBilling,
      osd: data.isOsd,
      afterhours: data.isAfterhours,
      driver: data.isDriver,
      primary_contact: data.isPrimary,
      primary_phone: data.primaryPhone,
      owner: data.isOwner,
      other: data.isOther,
      freight_matching_subscribed: data.freightMatching ? "Y" : "N",
    };

    const customProperties = [
      "isDispatch",
      "isBilling",
      "isOsd",
      "isAfterhours",
      "isPrimary",
      "isActive",
      "primaryPhone",
      "freightMatching",
      "mobile"
    ];

    customProperties.forEach(prop => delete payload[prop]);
    return payload;
  }

  static deSerialize(data) {
    return {
      id: data.id,
      name: data.name,
      phone: data.phone,
      mobile: data.mobile_phone,
      fax: data.fax,
      email: data.email,
      isDispatch: nullCheck(data, false, "dispatch"),
      isBilling: nullCheck(data, false, "billing"),
      isOsd: nullCheck(data, false, "osd"),
      isAfterhours: nullCheck(data, false, "afterhours"),
      isDriver: nullCheck(data, false, "driver"),
      isPrimary: nullCheck(data, false, "primary_contact"),
      isActive: nullCheck(data, false, "is_active"),
      primaryPhone: nullCheck(data, "", "primary_phone"),
      isOwner: nullCheck(data, false, "owner"),
      isOther: nullCheck(data, false, "other"),
      freightMatching: data.freight_matching_subscribed === "Y" ? true : false,
      ...data
    };
  }
}